// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file trade/v1/salesOrder.proto (package trade.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { WeightDisplayUnit } from "./weight_display_unit_pb.js";
import { file_trade_v1_weight_display_unit } from "./weight_display_unit_pb.js";
import type { Address, Base, FreightTerm, ID, Money, PaymentTerm, Unit } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file trade/v1/salesOrder.proto.
 */
export const file_trade_v1_salesOrder: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_struct, file_google_protobuf_timestamp, file_trade_v1_weight_display_unit, file_types]);

/**
 * SalesOrderLineItem represents a line item in a sales order
 *
 * @generated from message trade.v1.SalesOrderLineItem
 */
export type SalesOrderLineItem = Message<"trade.v1.SalesOrderLineItem"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID item_id = 2;
   */
  itemId?: ID;

  /**
   * @generated from field: types.Unit unit = 3;
   */
  unit: Unit;

  /**
   * @generated from field: string quantity = 4;
   */
  quantity: string;

  /**
   * @generated from field: types.Money unit_price = 5;
   */
  unitPrice?: Money;

  /**
   * @generated from field: types.Money total_price = 6;
   */
  totalPrice?: Money;

  /**
   * @generated from field: types.Base base = 7;
   */
  base?: Base;
};

/**
 * Describes the message trade.v1.SalesOrderLineItem.
 * Use `create(SalesOrderLineItemSchema)` to create a new message.
 */
export const SalesOrderLineItemSchema: GenMessage<SalesOrderLineItem> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 0);

/**
 * SalesOrder represents a sales order
 *
 * @generated from message trade.v1.SalesOrder
 */
export type SalesOrder = Message<"trade.v1.SalesOrder"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string document_number = 2;
   */
  documentNumber: string;

  /**
   * @generated from field: trade.v1.SalesOrderType type = 3;
   */
  type: SalesOrderType;

  /**
   * @generated from field: trade.v1.SalesOrderStatus status = 4;
   */
  status: SalesOrderStatus;

  /**
   * @generated from field: types.ID facility_id = 5;
   */
  facilityId?: ID;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 6;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 7;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: types.ID account_id = 8;
   */
  accountId?: ID;

  /**
   * @generated from field: string counterparty_reference_number = 9;
   */
  counterpartyReferenceNumber: string;

  /**
   * @generated from field: types.ID contact_id = 10;
   */
  contactId?: ID;

  /**
   * @generated from field: types.ID account_representative_id = 11;
   */
  accountRepresentativeId?: ID;

  /**
   * @generated from field: types.ID shipping_address_id = 12;
   */
  shippingAddressId?: ID;

  /**
   * @generated from field: types.Address shipping_address = 13;
   */
  shippingAddress?: Address;

  /**
   * @generated from field: types.ID billing_address_id = 14;
   */
  billingAddressId?: ID;

  /**
   * @generated from field: types.Address billing_address = 15;
   */
  billingAddress?: Address;

  /**
   * @generated from field: string payment_currency = 16;
   */
  paymentCurrency: string;

  /**
   * @generated from field: types.FreightTerm freight_term = 17;
   */
  freightTerm: FreightTerm;

  /**
   * @generated from field: types.PaymentTerm payment_term = 18;
   */
  paymentTerm: PaymentTerm;

  /**
   * @generated from field: string recycler_external_notes = 19;
   */
  recyclerExternalNotes: string;

  /**
   * @generated from field: string recycler_internal_notes = 20;
   */
  recyclerInternalNotes: string;

  /**
   * @generated from field: string customer_external_notes = 25;
   */
  customerExternalNotes: string;

  /**
   * @generated from field: string customer_internal_notes = 26;
   */
  customerInternalNotes: string;

  /**
   * @generated from field: string completion_notes = 21;
   */
  completionNotes: string;

  /**
   * @generated from field: repeated trade.v1.SalesOrderLineItem line_items = 22;
   */
  lineItems: SalesOrderLineItem[];

  /**
   * @generated from field: types.Base base = 23;
   */
  base?: Base;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 24;
   */
  customAttributes: { [key: string]: Value };

  /**
   * @generated from field: trade.v1.WeightDisplayUnit weight_display_unit = 27;
   */
  weightDisplayUnit: WeightDisplayUnit;
};

/**
 * Describes the message trade.v1.SalesOrder.
 * Use `create(SalesOrderSchema)` to create a new message.
 */
export const SalesOrderSchema: GenMessage<SalesOrder> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 1);

/**
 * SalesOrderFilter represents filter options for sales orders
 *
 * @generated from message trade.v1.SalesOrderFilter
 */
export type SalesOrderFilter = Message<"trade.v1.SalesOrderFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: repeated trade.v1.SalesOrderType type = 2;
   */
  type: SalesOrderType[];

  /**
   * @generated from field: repeated trade.v1.SalesOrderStatus status = 3;
   */
  status: SalesOrderStatus[];

  /**
   * @generated from field: string document_number = 4;
   */
  documentNumber: string;

  /**
   * @generated from field: repeated types.ID account_ids = 5;
   */
  accountIds: ID[];

  /**
   * @generated from field: repeated types.ID facility_ids = 6;
   */
  facilityIds: ID[];

  /**
   * @generated from field: repeated types.ID contact_ids = 7;
   */
  contactIds: ID[];

  /**
   * @generated from field: repeated types.ID account_representative_ids = 8;
   */
  accountRepresentativeIds: ID[];

  /**
   * @generated from field: repeated string payment_currencies = 9;
   */
  paymentCurrencies: string[];

  /**
   * @generated from field: repeated types.FreightTerm freight_terms = 10;
   */
  freightTerms: FreightTerm[];

  /**
   * @generated from field: repeated types.PaymentTerm payment_terms = 11;
   */
  paymentTerms: PaymentTerm[];

  /**
   * @generated from field: string counterparty_reference_number = 12;
   */
  counterpartyReferenceNumber: string;

  /**
   * @generated from field: google.protobuf.Timestamp from_start_date = 13;
   */
  fromStartDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp to_start_date = 14;
   */
  toStartDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp from_end_date = 15;
   */
  fromEndDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp to_end_date = 16;
   */
  toEndDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp from_created_at = 24;
   */
  fromCreatedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp to_created_at = 25;
   */
  toCreatedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp last_updated_at = 17;
   */
  lastUpdatedAt?: Timestamp;

  /**
   * @generated from field: string search_term = 18;
   */
  searchTerm: string;

  /**
   * @generated from field: types.ID organization_id = 19;
   */
  organizationId?: ID;

  /**
   * @generated from field: bool include_line_items = 20;
   */
  includeLineItems: boolean;

  /**
   * @generated from field: int32 offset = 21;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 22;
   */
  limit: number;

  /**
   * @generated from field: repeated string sorting = 23;
   */
  sorting: string[];

  /**
   * @generated from field: repeated types.ID created_by = 26;
   */
  createdBy: ID[];

  /**
   * @generated from field: repeated types.ID updated_by = 27;
   */
  updatedBy: ID[];
};

/**
 * Describes the message trade.v1.SalesOrderFilter.
 * Use `create(SalesOrderFilterSchema)` to create a new message.
 */
export const SalesOrderFilterSchema: GenMessage<SalesOrderFilter> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 2);

/**
 * GetSalesOrdersRequest is a request to get sales orders by IDs
 *
 * @generated from message trade.v1.GetSalesOrdersRequest
 */
export type GetSalesOrdersRequest = Message<"trade.v1.GetSalesOrdersRequest"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: bool include_line_items = 2;
   */
  includeLineItems: boolean;
};

/**
 * Describes the message trade.v1.GetSalesOrdersRequest.
 * Use `create(GetSalesOrdersRequestSchema)` to create a new message.
 */
export const GetSalesOrdersRequestSchema: GenMessage<GetSalesOrdersRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 3);

/**
 * GetSalesOrdersResponse is a response containing sales orders
 *
 * @generated from message trade.v1.GetSalesOrdersResponse
 */
export type GetSalesOrdersResponse = Message<"trade.v1.GetSalesOrdersResponse"> & {
  /**
   * @generated from field: repeated trade.v1.SalesOrder sales_orders = 1;
   */
  salesOrders: SalesOrder[];
};

/**
 * Describes the message trade.v1.GetSalesOrdersResponse.
 * Use `create(GetSalesOrdersResponseSchema)` to create a new message.
 */
export const GetSalesOrdersResponseSchema: GenMessage<GetSalesOrdersResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 4);

/**
 * ListSalesOrdersRequest is a request to list sales orders with filtering
 *
 * @generated from message trade.v1.ListSalesOrdersRequest
 */
export type ListSalesOrdersRequest = Message<"trade.v1.ListSalesOrdersRequest"> & {
  /**
   * @generated from field: trade.v1.SalesOrderFilter filter = 1;
   */
  filter?: SalesOrderFilter;
};

/**
 * Describes the message trade.v1.ListSalesOrdersRequest.
 * Use `create(ListSalesOrdersRequestSchema)` to create a new message.
 */
export const ListSalesOrdersRequestSchema: GenMessage<ListSalesOrdersRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 5);

/**
 * ListSalesOrdersResponse is a response containing a list of sales orders
 *
 * @generated from message trade.v1.ListSalesOrdersResponse
 */
export type ListSalesOrdersResponse = Message<"trade.v1.ListSalesOrdersResponse"> & {
  /**
   * @generated from field: repeated trade.v1.SalesOrder sales_orders = 1;
   */
  salesOrders: SalesOrder[];

  /**
   * @generated from field: int32 total_results = 2;
   */
  totalResults: number;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset: number;
};

/**
 * Describes the message trade.v1.ListSalesOrdersResponse.
 * Use `create(ListSalesOrdersResponseSchema)` to create a new message.
 */
export const ListSalesOrdersResponseSchema: GenMessage<ListSalesOrdersResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 6);

/**
 * SalesOrderInput is the input for creating a sales order
 *
 * @generated from message trade.v1.SalesOrderInput
 */
export type SalesOrderInput = Message<"trade.v1.SalesOrderInput"> & {
  /**
   * @generated from field: types.ID id = 26;
   */
  id?: ID;

  /**
   * @generated from field: string document_number = 1;
   */
  documentNumber: string;

  /**
   * @generated from field: trade.v1.SalesOrderType type = 2;
   */
  type: SalesOrderType;

  /**
   * @generated from field: trade.v1.SalesOrderStatus status = 3;
   */
  status: SalesOrderStatus;

  /**
   * @generated from field: types.ID facility_id = 4;
   */
  facilityId?: ID;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 5;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 6;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: types.ID account_id = 7;
   */
  accountId?: ID;

  /**
   * @generated from field: string counterparty_reference_number = 8;
   */
  counterpartyReferenceNumber: string;

  /**
   * @generated from field: types.ID contact_id = 9;
   */
  contactId?: ID;

  /**
   * @generated from field: types.ID account_representative_id = 10;
   */
  accountRepresentativeId?: ID;

  /**
   * @generated from field: types.ID shipping_address_id = 11;
   */
  shippingAddressId?: ID;

  /**
   * @generated from field: types.Address shipping_address = 12;
   */
  shippingAddress?: Address;

  /**
   * @generated from field: types.ID billing_address_id = 13;
   */
  billingAddressId?: ID;

  /**
   * @generated from field: types.Address billing_address = 14;
   */
  billingAddress?: Address;

  /**
   * @generated from field: string payment_currency = 15;
   */
  paymentCurrency: string;

  /**
   * @generated from field: string freight_term = 16;
   */
  freightTerm: string;

  /**
   * @generated from field: string payment_term = 17;
   */
  paymentTerm: string;

  /**
   * @generated from field: string recycler_external_notes = 18;
   */
  recyclerExternalNotes: string;

  /**
   * @generated from field: string recycler_internal_notes = 19;
   */
  recyclerInternalNotes: string;

  /**
   * @generated from field: string customer_external_notes = 23;
   */
  customerExternalNotes: string;

  /**
   * @generated from field: string customer_internal_notes = 24;
   */
  customerInternalNotes: string;

  /**
   * @generated from field: string completion_notes = 20;
   */
  completionNotes: string;

  /**
   * @generated from field: repeated trade.v1.SalesOrderLineItemInput line_items = 21;
   */
  lineItems: SalesOrderLineItemInput[];

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 22;
   */
  customAttributes: { [key: string]: Value };

  /**
   * @generated from field: trade.v1.WeightDisplayUnit weight_display_unit = 25;
   */
  weightDisplayUnit: WeightDisplayUnit;
};

/**
 * Describes the message trade.v1.SalesOrderInput.
 * Use `create(SalesOrderInputSchema)` to create a new message.
 */
export const SalesOrderInputSchema: GenMessage<SalesOrderInput> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 7);

/**
 * SalesOrderLineItemInput is the input for a line item
 *
 * @generated from message trade.v1.SalesOrderLineItemInput
 */
export type SalesOrderLineItemInput = Message<"trade.v1.SalesOrderLineItemInput"> & {
  /**
   * @generated from field: types.ID id = 6;
   */
  id?: ID;

  /**
   * @generated from field: types.ID item_id = 1;
   */
  itemId?: ID;

  /**
   * @generated from field: string unit = 2;
   */
  unit: string;

  /**
   * @generated from field: string quantity = 3;
   */
  quantity: string;

  /**
   * @generated from field: types.Money unit_price = 4;
   */
  unitPrice?: Money;

  /**
   * @generated from field: types.Money total_price = 5;
   */
  totalPrice?: Money;
};

/**
 * Describes the message trade.v1.SalesOrderLineItemInput.
 * Use `create(SalesOrderLineItemInputSchema)` to create a new message.
 */
export const SalesOrderLineItemInputSchema: GenMessage<SalesOrderLineItemInput> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 8);

/**
 * SalesOrderUpdateInput is the input for updating a sales order
 *
 * @generated from message trade.v1.SalesOrderUpdateInput
 */
export type SalesOrderUpdateInput = Message<"trade.v1.SalesOrderUpdateInput"> & {
  /**
   * @generated from field: string document_number = 1;
   */
  documentNumber: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: types.ID facility_id = 4;
   */
  facilityId?: ID;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 5;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 6;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: types.ID account_id = 7;
   */
  accountId?: ID;

  /**
   * @generated from field: string counterparty_reference_number = 8;
   */
  counterpartyReferenceNumber: string;

  /**
   * @generated from field: types.ID contact_id = 9;
   */
  contactId?: ID;

  /**
   * @generated from field: types.ID account_representative_id = 10;
   */
  accountRepresentativeId?: ID;

  /**
   * @generated from field: types.ID shipping_address_id = 11;
   */
  shippingAddressId?: ID;

  /**
   * @generated from field: types.Address shipping_address = 12;
   */
  shippingAddress?: Address;

  /**
   * @generated from field: types.ID billing_address_id = 13;
   */
  billingAddressId?: ID;

  /**
   * @generated from field: types.Address billing_address = 14;
   */
  billingAddress?: Address;

  /**
   * @generated from field: string payment_currency = 15;
   */
  paymentCurrency: string;

  /**
   * @generated from field: string freight_term = 16;
   */
  freightTerm: string;

  /**
   * @generated from field: string payment_term = 17;
   */
  paymentTerm: string;

  /**
   * @generated from field: string recycler_external_notes = 18;
   */
  recyclerExternalNotes: string;

  /**
   * @generated from field: string recycler_internal_notes = 19;
   */
  recyclerInternalNotes: string;

  /**
   * @generated from field: string customer_external_notes = 23;
   */
  customerExternalNotes: string;

  /**
   * @generated from field: string customer_internal_notes = 24;
   */
  customerInternalNotes: string;

  /**
   * @generated from field: string completion_notes = 20;
   */
  completionNotes: string;

  /**
   * @generated from field: repeated trade.v1.SalesOrderLineItemInput line_items = 21;
   */
  lineItems: SalesOrderLineItemInput[];

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 22;
   */
  customAttributes: { [key: string]: Value };

  /**
   * @generated from field: trade.v1.WeightDisplayUnit weight_display_unit = 25;
   */
  weightDisplayUnit: WeightDisplayUnit;
};

/**
 * Describes the message trade.v1.SalesOrderUpdateInput.
 * Use `create(SalesOrderUpdateInputSchema)` to create a new message.
 */
export const SalesOrderUpdateInputSchema: GenMessage<SalesOrderUpdateInput> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 9);

/**
 * CreateSalesOrderRequest is a request to create a new sales order
 *
 * @generated from message trade.v1.CreateSalesOrderRequest
 */
export type CreateSalesOrderRequest = Message<"trade.v1.CreateSalesOrderRequest"> & {
  /**
   * @generated from field: trade.v1.SalesOrderInput input = 1;
   */
  input?: SalesOrderInput;
};

/**
 * Describes the message trade.v1.CreateSalesOrderRequest.
 * Use `create(CreateSalesOrderRequestSchema)` to create a new message.
 */
export const CreateSalesOrderRequestSchema: GenMessage<CreateSalesOrderRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 10);

/**
 * CreateSalesOrderResponse is a response containing the created sales order
 *
 * @generated from message trade.v1.CreateSalesOrderResponse
 */
export type CreateSalesOrderResponse = Message<"trade.v1.CreateSalesOrderResponse"> & {
  /**
   * @generated from field: trade.v1.SalesOrder sales_order = 1;
   */
  salesOrder?: SalesOrder;
};

/**
 * Describes the message trade.v1.CreateSalesOrderResponse.
 * Use `create(CreateSalesOrderResponseSchema)` to create a new message.
 */
export const CreateSalesOrderResponseSchema: GenMessage<CreateSalesOrderResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 11);

/**
 * UpdateSalesOrderRequest is a request to update an existing sales order
 *
 * @generated from message trade.v1.UpdateSalesOrderRequest
 */
export type UpdateSalesOrderRequest = Message<"trade.v1.UpdateSalesOrderRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: trade.v1.SalesOrderUpdateInput input = 2;
   */
  input?: SalesOrderUpdateInput;
};

/**
 * Describes the message trade.v1.UpdateSalesOrderRequest.
 * Use `create(UpdateSalesOrderRequestSchema)` to create a new message.
 */
export const UpdateSalesOrderRequestSchema: GenMessage<UpdateSalesOrderRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 12);

/**
 * UpdateSalesOrderResponse is a response containing the updated sales order
 *
 * @generated from message trade.v1.UpdateSalesOrderResponse
 */
export type UpdateSalesOrderResponse = Message<"trade.v1.UpdateSalesOrderResponse"> & {
  /**
   * @generated from field: trade.v1.SalesOrder sales_order = 1;
   */
  salesOrder?: SalesOrder;
};

/**
 * Describes the message trade.v1.UpdateSalesOrderResponse.
 * Use `create(UpdateSalesOrderResponseSchema)` to create a new message.
 */
export const UpdateSalesOrderResponseSchema: GenMessage<UpdateSalesOrderResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 13);

/**
 * DeleteSalesOrderRequest is a request to delete a sales order
 *
 * @generated from message trade.v1.DeleteSalesOrderRequest
 */
export type DeleteSalesOrderRequest = Message<"trade.v1.DeleteSalesOrderRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;
};

/**
 * Describes the message trade.v1.DeleteSalesOrderRequest.
 * Use `create(DeleteSalesOrderRequestSchema)` to create a new message.
 */
export const DeleteSalesOrderRequestSchema: GenMessage<DeleteSalesOrderRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 14);

/**
 * DeleteSalesOrderResponse is a response indicating the success of deletion
 *
 * @generated from message trade.v1.DeleteSalesOrderResponse
 */
export type DeleteSalesOrderResponse = Message<"trade.v1.DeleteSalesOrderResponse"> & {
};

/**
 * Describes the message trade.v1.DeleteSalesOrderResponse.
 * Use `create(DeleteSalesOrderResponseSchema)` to create a new message.
 */
export const DeleteSalesOrderResponseSchema: GenMessage<DeleteSalesOrderResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 15);

/**
 * Request message for retrieving sales orders by custom attribute
 *
 * @generated from message trade.v1.GetSalesOrdersByCustomAttributeRequest
 */
export type GetSalesOrdersByCustomAttributeRequest = Message<"trade.v1.GetSalesOrdersByCustomAttributeRequest"> & {
  /**
   * @generated from field: string attribute_name = 1;
   */
  attributeName: string;

  /**
   * @generated from field: repeated google.protobuf.Value attribute_values = 2;
   */
  attributeValues: Value[];
};

/**
 * Describes the message trade.v1.GetSalesOrdersByCustomAttributeRequest.
 * Use `create(GetSalesOrdersByCustomAttributeRequestSchema)` to create a new message.
 */
export const GetSalesOrdersByCustomAttributeRequestSchema: GenMessage<GetSalesOrdersByCustomAttributeRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 16);

/**
 * Response message for the GetSalesOrdersByCustomAttribute RPC
 *
 * @generated from message trade.v1.GetSalesOrdersByCustomAttributeResponse
 */
export type GetSalesOrdersByCustomAttributeResponse = Message<"trade.v1.GetSalesOrdersByCustomAttributeResponse"> & {
  /**
   * @generated from field: repeated trade.v1.SalesOrder sales_orders = 1;
   */
  salesOrders: SalesOrder[];
};

/**
 * Describes the message trade.v1.GetSalesOrdersByCustomAttributeResponse.
 * Use `create(GetSalesOrdersByCustomAttributeResponseSchema)` to create a new message.
 */
export const GetSalesOrdersByCustomAttributeResponseSchema: GenMessage<GetSalesOrdersByCustomAttributeResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 17);

/**
 * Request message for checking search permissions on sales orders
 *
 * @generated from message trade.v1.CheckSalesOrderSearchPermissionsRequest
 */
export type CheckSalesOrderSearchPermissionsRequest = Message<"trade.v1.CheckSalesOrderSearchPermissionsRequest"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];
};

/**
 * Describes the message trade.v1.CheckSalesOrderSearchPermissionsRequest.
 * Use `create(CheckSalesOrderSearchPermissionsRequestSchema)` to create a new message.
 */
export const CheckSalesOrderSearchPermissionsRequestSchema: GenMessage<CheckSalesOrderSearchPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 18);

/**
 * Response message for the CheckSearchPermissions RPC
 *
 * @generated from message trade.v1.CheckSalesOrderSearchPermissionsResponse
 */
export type CheckSalesOrderSearchPermissionsResponse = Message<"trade.v1.CheckSalesOrderSearchPermissionsResponse"> & {
  /**
   * @generated from field: repeated types.ID permitted_ids = 1;
   */
  permittedIds: ID[];
};

/**
 * Describes the message trade.v1.CheckSalesOrderSearchPermissionsResponse.
 * Use `create(CheckSalesOrderSearchPermissionsResponseSchema)` to create a new message.
 */
export const CheckSalesOrderSearchPermissionsResponseSchema: GenMessage<CheckSalesOrderSearchPermissionsResponse> = /*@__PURE__*/
  messageDesc(file_trade_v1_salesOrder, 19);

/**
 * SalesOrderStatus represents the status of a sales order
 *
 * @generated from enum trade.v1.SalesOrderStatus
 */
export enum SalesOrderStatus {
  /**
   * @generated from enum value: SALES_ORDER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SALES_ORDER_STATUS_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: SALES_ORDER_STATUS_VOIDED = 2;
   */
  VOIDED = 2,

  /**
   * @generated from enum value: SALES_ORDER_STATUS_OPEN = 3;
   */
  OPEN = 3,

  /**
   * @generated from enum value: SALES_ORDER_STATUS_FINISHED = 4;
   */
  FINISHED = 4,
}

/**
 * Describes the enum trade.v1.SalesOrderStatus.
 */
export const SalesOrderStatusSchema: GenEnum<SalesOrderStatus> = /*@__PURE__*/
  enumDesc(file_trade_v1_salesOrder, 0);

/**
 * SalesOrderType represents the type of a sales order
 *
 * @generated from enum trade.v1.SalesOrderType
 */
export enum SalesOrderType {
  /**
   * @generated from enum value: SALES_ORDER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SALES_ORDER_TYPE_DOMESTIC = 1;
   */
  DOMESTIC = 1,

  /**
   * @generated from enum value: SALES_ORDER_TYPE_INTERNATIONAL = 2;
   */
  INTERNATIONAL = 2,
}

/**
 * Describes the enum trade.v1.SalesOrderType.
 */
export const SalesOrderTypeSchema: GenEnum<SalesOrderType> = /*@__PURE__*/
  enumDesc(file_trade_v1_salesOrder, 1);

/**
 * SalesOrderQueriesService provides read methods for sales order management
 *
 * @generated from service trade.v1.SalesOrderQueriesService
 */
export const SalesOrderQueriesService: GenService<{
  /**
   * GetSalesOrders retrieves sales orders by IDs
   *
   * @generated from rpc trade.v1.SalesOrderQueriesService.GetSalesOrders
   */
  getSalesOrders: {
    methodKind: "unary";
    input: typeof GetSalesOrdersRequestSchema;
    output: typeof GetSalesOrdersResponseSchema;
  },
  /**
   * ListSalesOrders lists sales orders with filtering
   *
   * @generated from rpc trade.v1.SalesOrderQueriesService.ListSalesOrders
   */
  listSalesOrders: {
    methodKind: "unary";
    input: typeof ListSalesOrdersRequestSchema;
    output: typeof ListSalesOrdersResponseSchema;
  },
  /**
   * GetSalesOrdersByCustomAttribute retrieves sales orders by a custom attribute
   *
   * @generated from rpc trade.v1.SalesOrderQueriesService.GetSalesOrdersByCustomAttribute
   */
  getSalesOrdersByCustomAttribute: {
    methodKind: "unary";
    input: typeof GetSalesOrdersByCustomAttributeRequestSchema;
    output: typeof GetSalesOrdersByCustomAttributeResponseSchema;
  },
  /**
   * CheckSearchPermissions checks which of the provided sales order IDs the user has permission to access
   *
   * @generated from rpc trade.v1.SalesOrderQueriesService.CheckSearchPermissions
   */
  checkSearchPermissions: {
    methodKind: "unary";
    input: typeof CheckSalesOrderSearchPermissionsRequestSchema;
    output: typeof CheckSalesOrderSearchPermissionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_trade_v1_salesOrder, 0);

/**
 * SalesOrderCommandsService provides write methods for sales order management
 *
 * @generated from service trade.v1.SalesOrderCommandsService
 */
export const SalesOrderCommandsService: GenService<{
  /**
   * CreateSalesOrder creates a new sales order
   *
   * @generated from rpc trade.v1.SalesOrderCommandsService.CreateSalesOrder
   */
  createSalesOrder: {
    methodKind: "unary";
    input: typeof CreateSalesOrderRequestSchema;
    output: typeof CreateSalesOrderResponseSchema;
  },
  /**
   * UpdateSalesOrder updates an existing sales order
   *
   * @generated from rpc trade.v1.SalesOrderCommandsService.UpdateSalesOrder
   */
  updateSalesOrder: {
    methodKind: "unary";
    input: typeof UpdateSalesOrderRequestSchema;
    output: typeof UpdateSalesOrderResponseSchema;
  },
  /**
   * DeleteSalesOrder deletes a sales order
   *
   * @generated from rpc trade.v1.SalesOrderCommandsService.DeleteSalesOrder
   */
  deleteSalesOrder: {
    methodKind: "unary";
    input: typeof DeleteSalesOrderRequestSchema;
    output: typeof DeleteSalesOrderResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_trade_v1_salesOrder, 1);

